import MenuItemSize from './MenuItemSize'

export default MenuItemSize
